import axios from "axios";
import { server } from "../../App";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import moment from "moment";

const serverCHARTS = process.env.REACT_APP_SERVER_CHARTS;

export const getData = (date, medecin) => {
  let url;
  // url = `${server}actes/ActesAtDate/2021-09-10`;
  url = `${server}actes/ActesAtDate/${date}/${medecin}`;

  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const getAllMutu = () => {
  return axios
    .get(`${server}mutuelle`, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const getDoctors = () => {

  let my_url = `${serverCHARTS}/authentication/GetDoctors`

  return axios
    .get(my_url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const GetAllType_D_Operation = () => {
  return axios
    .get(`${server}PriseEnCharge/GetAllType_D_Operation`, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const GetALLCLINICS = () => {
  return axios
    .get(`${server}Bloc/GetALLCLINICS`, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};

const CreateOneUser = (data) => {
  return axios({
    method: "POST",
    responseType: "json",
    url: `${server}users`,
    data: data,
    headers: {
      jwtoken: sessionStorage.token,
    },
  })
    .then((response) => {
      toast.success("Successfully created", {
        position: toast.POSITION.TOP_CENTER,
      });
      return response;
    })
    .catch(() =>
      toast.error("error", {
        position: toast.POSITION.TOP_CENTER,
      })
    );
};

export const useAddUser = () => {
  return useMutation(CreateOneUser);
};

const updateOneUser = (data) => {
  axios({
    method: "put",
    responseType: "json",
    url: `${server}users/${data.idpatient}`,
    data: data,
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

export const useUpdateUser = () => {
  return useMutation(updateOneUser);
};

export const handleUpdateMutuelle = ({
  fk_id_patient1,
  date_consultation_For_Server,
  mutuelle_faite,
}) => {
  const date_For_Server = moment(date_consultation_For_Server).format(
    "YYYY-MM-DD"
  );
  let mutuelle_faite_modifie = !mutuelle_faite;
  let data = {
    fk_id_patient1,
    date_For_Server,
    mutuelle_faite: mutuelle_faite_modifie,
  };

  return axios({
    method: "put",
    responseType: "json",
    url: `${server}actes/updateMutuelle`,
    data,
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

// export const useUpdateMutuelle = () => {
//   return useMutation(handleUpdateMutuelle);
// };

export const getMutuelleForOneUser = (id) => {
  let url = `${server}actes/ActesOneUserGrouped/${id}`;
  return axios.get(url, {
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

export const One_user_actes_per_Day = (id, date_consultation) => {
  let url = `${server}actes/ActesOneUserAtDate/${date_consultation}/${id}`;
  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => {
      return response.data;
    });
};

export const Add_Products_To_user = (data) => {
  axios({
    method: "POST",
    responseType: "json",
    url: `${server}actes`,
    data: data,
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

export const GetProducts = () => {
  let url = `${server}products/`;

  return axios.get(url, {
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};
export const GetProducts2 = () => {

  let my_url = `${serverCHARTS}/products/`;

  return axios.get(my_url, {
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

export const remove_prod_from_user = ({
  fk_id_acte,
  fk_id_patient1,
  date_consultation,

}) => {
  return axios({
    method: "DELETE",
    responseType: "json",
    url: `${server}actes/deleteActe/${fk_id_acte}/${date_consultation}/${fk_id_patient1}`,
    headers: {
      jwtoken: sessionStorage.token,
    },
  });
};

export const actesAtDate = (date_consultation) => {
  // console.log("11111111", date_consultation);

  let url = `${server}actes/ActesAtDate/${date_consultation}`;
  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const ActesAtDateFooter = (date_consultation) => {
  // console.log("2222222222", date_consultation);
  let url = `${server}actes/ActesAtDateFooter/${date_consultation}`;

  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const emptyState_form_load = {
  idpatient: "",
  nom: "",
  prenom: "",
  civilite: "",
  nom_mutuelle: "",
  fk_id_liste_mutuelle: "",
  fk_id_civilite: "",
  cin: "",
  date_naissance: "",
  commentaire_sur_patient: "",
  tel: "",
  tel2: "",
  tel3: "",
};
export const emptyState_act_form_load = {
  age: "",
  nom: "",
  prenom: "",
  couleur: "",
  created_at: "",
  date_consultation: "",
  date_naissance: "",
  done: "",
  fk_id_acte: "",
  fk_id_patient1: "",
  nom_acte: "",
  rest: "",
  sum_act: "",
  bloc: "",
  didnt_come: "",
};

export const InitialRowData1And2 = {
  rowData: [],
  rowData2: [],
};

export const payment_axios_func = (data) => {
  let url = `${server}actes/GetAllActesForOneUser/${data}`;
  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
export const paymentAt_Date_axios_func = (data) => {
  let url = `${server}actes/ActesOneUserAtDate/${data.date}/${data.id}`;
  return axios
    .get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
    .then((response) => response.data);
};
